<template>
  <div>
    <div class="insights-container container-fluid py-3 px-5">
          <div class="text-center mb-3">
            <h1 class="title-page mb-1">{{ month }} Insights</h1>
            <p class="sub-title">Monthly Performance Summary</p>
          </div>

      <!-- TOP ARRIVALS -->
      <div class="main-card arrival-card mb-3 p-3 shadow-sm">
        <div class="d-flex align-items-center mb-1 ">
          <div style="color: #a9323d;">
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
              class="w-20 h-20"
            >
              <path d="M6 4h12v4c0 3.3-2.7 6-6 6s-6-2.7-6-6V4z"></path>
              <path d="M18 5c1.7 0 3 1.3 3 3s-1.3 3-3 3"></path>
              <path d="M6 5c-1.7 0-3 1.3-3 3s1.3 3 3 3"></path>
              <path d="M12 14v4"></path>
              <path d="M8 21h8"></path>
            </svg>
            
          </div>
          <h3 class="mb-0 section-title"> 
            Top 3 Early Arrivals This Month
          </h3>
        </div>
        <div class="row px-2">
          <div
            v-for="(item, index) in topArrivals"
            :key="index"
            class="col-md-4 mb-3 mb-md-0"
          >
            <div class="rank-box h-100 shadow-sm border">
              <h1 class="rank-number silver"
                style="
                  font-size: 1.5rem;
                  line-height: 1;
                  font-weight: 700;
                  letter-spacing: -0.025em;
                  
                "
              >#{{ index + 1 }}</h1>
              <p class="name font-weight-bold mb-1">{{ item.name }}</p>
              <p class="avg-time">Avg: {{ item.time }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- INFO CARDS -->
      <div class="row">
        <div class="col-lg-5 mb-4">
          <div class="info-card h-100 p-4 shadow-sm border bg-white">
            <div class="d-flex align-items-center mb-4">
              <span class="icon mr-2 text-success" style="font-size: 2.25rem; ">📅</span>
              <h3 class="mb-0 font-weight-bold cards-title"
                  style="
                  font-size: 1.5rem; 
                  line-height: 2.5rem;
                  font-weight: 700;
                  color: #111827; 
                  "
              >Best Day of Week</h3>
            </div>
            <!-- width 100% -->
            <div class="text-center py-3 w-100" 
                  style="
                  height: 60%;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                ">
              <h1 class="day-highlight display-4 font-weight-bold">
                {{ bestDayOfWeek.day }}
              </h1>
              <p class="h5 text-dark my-3">
                Average: {{ bestDayOfWeek.current_avg }}
              </p>
              <!-- have two type up and down  -->
              <p class="text-success mb-0" v-if="bestDayOfWeek.trend === 'up'">
                <i data-feather="trending-up"></i>
                {{ bestDayOfWeek.label }}
              </p>
              <p class="text-danger mb-0" v-else>
                <i data-feather="trending-down"></i>
                {{ bestDayOfWeek.label }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-7 mb-4">
          <div class="info-card h-100 p-4 shadow-sm border bg-white">
            <div class="mb-4">
              <h4 class="mb-0 font-weight-bold cards-title">Weekly Trends</h4>
            </div>
            <div v-if="weeklyTrendsError" class="text-danger">
              Error: Could not load weekly trends data.
            </div>
            <div v-else-if="!weeklyTrends || weeklyTrends.length === 0" class="text-muted">
              No weekly trends data available for this month.
            </div>
            <div v-else class="row"> <div
    v-for="trend in weeklyTrends"
    :key="trend.day"
    class="col-md-6 mb-2" 
  >
    <div class="trend-row d-flex justify-content-between align-items-center p-2 rounded bg-light border">
      <p class="text-secondary font-weight-bold mb-0">{{ trend.day }}</p>
      <div>
        <span class="font-weight-bold mr-3">
          {{ trend.time }}
        </span>
        <span 
          :class="trend.trend === 'up' ? 'text-success' : 'text-danger'"
          class="small font-weight-bold"
        >
          <i 
            :data-feather="trend.trend === 'up' ? 'trending-up' : 'trending-down'"
            class="mr-1 w-25"
          ></i>
          {{ trend.diff }} mins
        </span>
      </div>
    </div>
  </div>
</div>
            <!-- <div
              v-else
              v-for="trend in weeklyTrends"
              :key="trend.day"
              class="trend-row d-flex justify-content-between align-items-center p-1 mb-1 rounded bg-light"
            >
              <p class="text-secondary font-weight-bold">{{ trend.day }}</p>
              <div>
                <span class="font-weight-bold mr-3">
                  {{ trend.time }}
                </span>
                <span 
                 :class="trend.trend === 'up' ? 'text-success' : 'text-danger'"
                 class=" small font-weight-bold">
                  <i 
                    :data-feather="trend.trend === 'up' ? 'trending-up' : 'trending-down'"
                    class="mr-1"
                  ></i>
                  {{ trend.diff }} mins
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- PEAK -->
      <div class="row ">
        <div class="col-12">
          <div class="peak-card p-2 rounded shadow text-center text-white">
            <p class="text-uppercase font-weight-bold mb-2 "
              style="letter-spacing: 2px;"
            >
              Peak Arrival Window
            </p>
            <h1 class="display-3 font-weight-bold mb-2">
              {{ peakWindow.window }}
            </h1>
            <p class="mb-0 ">
              {{ peakWindow.percentage }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {PUBLIC_DASHBOARD} from "../../../tenant/Config/ApiUrl";
import CoreLibrary from "../../../core/helpers/CoreLibrary";
import feather from 'feather-icons';
export default {
  name: "MonthlyInsights",
  extends: CoreLibrary,
  
  data() {
    return {
      month: "December",
      bestDayOfWeek: {
        label: "Best punctuality",
        current_avg: "08:50 AM",
        trend: "up",
        color: "green",
        message: "114 minutes earlier than last month."
      },
      topArrivals: [
        { name: "Ratanak S.", time: "7:58 AM" },
        { name: "Chun Phallamonunhh", time: "8:05 AM" },
        { name: "Sopheaktra M.", time: "8:12 AM" }
      ],
      weeklyTrends: [],
      weeklyTrendsError: false,
      peakWindow: {
        window: "Loading...",
        percentage: "Loading..."
      },
      timerInterval: null
    };
  },
  methods: {
    getmonthInsights() {
      axiosGet(`${PUBLIC_DASHBOARD}/month-insights`).then(({data}) => {
        this.month = data.month;
        this.topArrivals = data.top_3;
      });
    },
    getbestDayOfWeeks() { 
      axiosGet(`${PUBLIC_DASHBOARD}/best-day-of-week`).then(({data}) => {
        this.bestDayOfWeek = data;
      });
    },
    getweekTrends() {
      this.weeklyTrendsError = false;
      axiosGet(`${PUBLIC_DASHBOARD}/week-trends`)
        .then(({data}) => {
            this.weeklyTrends = data;
        })
        .catch(() => {
            this.weeklyTrendsError = true;
        });
    },
    getPeakWindow() {
      axiosGet(`${PUBLIC_DASHBOARD}/peak-arrival-windows`).then(({data}) => {
        this.peakWindow = data;
      });
    }
  },
  watch: {
    bestDayOfWeek: {
      handler() {
        this.$nextTick(() => {
          feather.replace();
        });
      },
      deep: true
    },
    weeklyTrends: {
      handler() {
        this.$nextTick(() => {
          feather.replace();
        });
      },
      deep: true
    }
  },
  created() {
    this.getmonthInsights();
    this.getbestDayOfWeeks();
    this.getweekTrends();
    this.getPeakWindow();
  },
  mounted() {
    this.$nextTick(() => {
      feather.replace();
    });
  },
};
</script>

<style scoped>
/* Base */
.insights-container {
  /* background-color: #f4f6f9; */
  /* Adjust the 100px to match your system header height exactly */
}

.main-card {
  background-color: #fef2f2;
  border-radius: 15px;
  border: 1px solid #fee2e2;
}
p .name{
  font-size : 1.5rem;
}
p .avg-time{
  font-size : 1rem;
}
/* New Styles */
.title-page {
    font-size: 1.6rem; /* text-5xl */
    line-height: 1; 
    font-weight: 1000; /* font-bold */
    color: rgb(17, 24, 39); /* text-gray-900 */
    letter-spacing: -0.025em; /* tracking-tight */
} 
.sub-title {
    font-size: 1rem; /* text-2xl (24px) */
    line-height: 2rem; 
    color: rgb(107, 114, 128); /* text-gray-500 */
}

.section-title{
  font-size: 1.2rem;  

}
.cards-title{
  font-size: 1.2rem;  

}
  .rank-number { font-size: 0.8rem; }
  .display-3 { font-size: 1.5rem; }

.rank-box {
  background: white;
  padding: 14px 14px;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.rank-box:hover {
  background-color: #a9323d;
  color: white;
  transform: translateY(-8px);
}

.rank-box:hover * {
  color: white !important;
}

.rank-number {
  font-size: 40px;
  font-weight: 900;
}

.silver { color: #dee2e6; }

.day-highlight { 
  color: #28a745; 
  font-size: 2rem; 
  line-height: 1; 
  font-weight: 700;
  letter-spacing: -0.025em; 
}

.peak-card { background-color: #a9323d; }

/* .opacity-75 { opacity: 0.75; } */

/* ================= */
/* RESPONSIVE RULES  */
/* ================= */

/* ≤1200px */


</style>